import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "text" }
const _hoisted_2 = {
  key: 0,
  class: "commentIcon"
}
const _hoisted_3 = { class: "label pallino mr-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-share" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "commentIcon"
}
const _hoisted_7 = { class: "label pallino mr-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-circle-o-down" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 2,
  class: "commentIcon"
}
const _hoisted_11 = { class: "label pallino mr-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-briefcase" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 3,
  class: "commentIcon"
}
const _hoisted_15 = { class: "label pallino mr-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-clock-o" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 4,
  class: "commentIcon"
}
const _hoisted_19 = { class: "label pallino mr-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-phone" }, null, -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  key: 5,
  class: "commentIcon"
}
const _hoisted_23 = { class: "label pallino mr-2" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check" }, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 6,
  class: "commentIcon"
}
const _hoisted_27 = { class: "label pallino mr-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times" }, null, -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = {
  key: 7,
  class: "commentIcon"
}
const _hoisted_31 = { class: "label pallino mr-2" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-ban" }, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = {
  key: 8,
  class: "commentIcon"
}
const _hoisted_35 = { class: "label pallino mr-2" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-envelope-o" }, null, -1)
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = {
  key: 9,
  class: "commentIcon"
}
const _hoisted_39 = { class: "label pallino mr-2" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-whatsapp" }, null, -1)
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = {
  key: 10,
  class: "commentIcon"
}
const _hoisted_43 = { class: "label pallino mr-2" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-commenting-o" }, null, -1)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = {
  key: 11,
  class: "commentIcon"
}
const _hoisted_47 = { class: "label pallino mr-2" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-rss" }, null, -1)
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = {
  key: 12,
  class: "commentIcon"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-rss" }, null, -1)
const _hoisted_52 = [
  _hoisted_51
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_leadstatus = _resolveDirective("leadstatus")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.comment.type == 'assegnazione')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_3, _hoisted_5)), [
            [_directive_leadstatus, _ctx.comment]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.comment.type == 'inserimento')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_7, _hoisted_9)), [
            [_directive_leadstatus, _ctx.comment]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.comment.type == 'da_fare')
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_11, _hoisted_13)), [
            [_directive_leadstatus, _ctx.comment]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.comment.type == 'in_attesa')
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_15, _hoisted_17)), [
            [_directive_leadstatus, _ctx.comment]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.comment.type == 'call')
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_19, _hoisted_21)), [
            [_directive_leadstatus, _ctx.comment]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.comment.type == 'acquisito')
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_23, _hoisted_25)), [
            [_directive_leadstatus, _ctx.comment]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.comment.type == 'perso')
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_27, _hoisted_29)), [
            [_directive_leadstatus, _ctx.comment]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.comment.type == 'cancellato')
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_31, _hoisted_33)), [
            [_directive_leadstatus, _ctx.comment]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.comment.type == 'messaggio')
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_35, _hoisted_37)), [
            [_directive_leadstatus, _ctx.comment]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.comment.type == 'whatsapp')
      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
          _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_39, _hoisted_41)), [
            [_directive_leadstatus, _ctx.comment]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.comment.type == 'commento')
      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
          _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_43, _hoisted_45)), [
            [_directive_leadstatus, _ctx.comment]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.comment.type == 'stato')
      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
          _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_47, _hoisted_49)), [
            [_directive_leadstatus, _ctx.comment]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.comment.type == 'sub_stato')
      ? (_openBlock(), _createElementBlock("div", _hoisted_50, _hoisted_52))
      : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(_ctx.comment.text), 1)
  ]))
}